import React from 'react';
import Page from '../../../../page';
import Utils from '../../../../utils';
import Formatter from '../../../../formatter';
import EmbedToolbarButtons from './EmbedToolbarButtons';
/**
 * @param {import('./types').EmbedToolbarProps} props
 */

var EmbedToolbar = function EmbedToolbar(props) {
  var title = props.title,
      canSave = props.canSave,
      enableAdvanced = props.enableAdvanced,
      disableCommands = props.disableCommands,
      runApi = props.runApi;
  var onClose = props.onClose,
      onSubmit = props.onSubmit,
      onSave = props.onSave,
      onRefreshPreview = props.onRefreshPreview;
  var state = runApi.state,
      actions = runApi.actions,
      runOptions = runApi.options;
  var discussion = state.discussion;
  var loaded = state.loaded,
      templates = state.templates,
      selectedTemplate = state.selectedTemplate,
      zoom = state.zoom;
  var dataVersions = state.dataVersions,
      currentDataVersion = state.currentDataVersion;

  var onChange = function onChange(template) {
    actions.selectTemplate(template);
  };

  var options = templates && templates.map(function (template) {
    return {
      label: Utils.path.getFileCaption(template),
      onClick: function onClick() {
        onChange(template);
      },
      selected: template === selectedTemplate
    };
  });
  var zoomValues = [{
    label: 'Zoom In',
    onClick: function onClick() {
      return actions.setZoom('zoomIn');
    }
  }, {
    label: 'Zoom Out',
    onClick: function onClick() {
      return actions.setZoom('zoomOut');
    }
  }, 'separator', {
    label: '100%',
    onClick: function onClick() {
      return actions.setZoom('100%');
    }
  }, {
    label: '200%',
    onClick: function onClick() {
      return actions.setZoom('200%');
    }
  }, 'separator', {
    label: 'Fit Entire Page',
    onClick: function onClick() {
      return actions.setZoom('fitEntirePage');
    }
  }, {
    label: 'Fit Width',
    onClick: function onClick() {
      return actions.setZoom('fitWidth');
    }
  }, 'separator', {
    label: 'Fit Two Pages',
    onClick: function onClick() {
      return actions.setZoom('fitTwoPages');
    }
  }];
  var value = selectedTemplate && Utils.path.getFileCaption(selectedTemplate);
  var controls = [];
  if (enableAdvanced && onSave) controls.push({
    type: 'icon',
    className: 'fa fa-save',
    onClick: onSave,
    disabled: !canSave || state.saving,
    label: 'Save',
    style: {
      color: '#000000'
    }
  });
  if (onSubmit) controls.push({
    type: 'icon',
    className: 'fa fa-play',
    onClick: onSubmit,
    style: {
      color: '#000000'
    }
  }); // create center controls after loaded

  if (loaded && state.view.hasDocumentView) {
    controls = controls.concat([{
      type: 'dropdown',
      options: options,
      value: value,
      disabled: state.view.hideDocumentView,
      style: {
        color: '#000000'
      }
    }]);

    if (runOptions.ManualPreviewRefresh) {
      controls = controls.concat([{
        type: 'icon',
        className: 'fa fa-sync',
        label: 'Reload document preview',
        disabled: false,
        onClick: onRefreshPreview,
        style: {
          color: '#000000'
        }
      }]);
    }

    controls = controls.concat([{
      type: 'divider'
    }, {
      type: 'icon',
      className: 'fa fa-search-plus',
      disabled: state.view.hideDocumentView,
      label: 'Zoom In',
      onClick: function onClick() {
        actions.setZoom('zoomIn');
      },
      style: {
        color: '#000000'
      }
    }, {
      type: 'dropdown',
      options: zoomValues,
      value: zoom || '100%',
      disabled: state.view.hideDocumentView,
      style: {
        color: '#000000'
      }
    }, {
      type: 'icon',
      className: 'fa fa-search-minus',
      disabled: state.view.hideDocumentView,
      label: 'Zoom Out',
      onClick: function onClick() {
        actions.setZoom('zoomOut');
      },
      style: {
        color: '#000000'
      }
    }]);
  } // if allow splitting, add a dropdown control for this


  if (loaded && state.view.allowViewSwitch) {
    controls.push({
      type: 'divider'
    });
    controls.push({
      type: 'icon',
      iconType: 'two-columns',
      label: 'Switch between views',
      onClick: function onClick() {
        actions.toggleViews();
      },
      style: {
        color: '#000000'
      }
    });
  }

  var rightControls = []; // discussion enabled only after templates were loaded

  if (runOptions.JobId && loaded && discussion && discussion.enabled) {
    rightControls.push({
      type: 'toggleIcon',
      className: 'fa fa-comment',
      checked: discussion.visible,
      onClick: function onClick() {
        actions.toggleDiscussion(!discussion.visible);
      },
      style: {
        color: '#000000'
      }
    });
  }

  if (enableAdvanced && runOptions.JobId) {
    if (dataVersions && dataVersions.length) {
      var version = dataVersions.find(function (v) {
        return v.Version === currentDataVersion;
      });
      var versionsControl = {
        type: 'dropdown',
        options: [],
        value: !version || version.Version === -1 ? 'Current Version' : React.createElement(Formatter.DateTime, {
          value: version.DateCreated,
          hideTooltip: true
        }),
        style: {
          color: '#000000'
        }
      };
      dataVersions.map(function (dataVersion) {
        versionsControl.options.push({
          label: dataVersion.DateCreated ? React.createElement(Formatter.DateTime, {
            value: dataVersion.DateCreated,
            hideTooltip: true
          }) : 'Current Version',
          onClick: function onClick() {
            actions.selectFormVersion(dataVersion.Version);
          },
          selected: dataVersion.Version === currentDataVersion
        });
      });
      rightControls.push(versionsControl);
    }

    if (runOptions.ShowAdvancedMenu) {
      var moreOptionsControl = {
        type: 'moreOptions',
        options: []
      };
      var downloadXmlBtn = {
        label: 'Download This Version',
        onClick: function onClick() {
          actions.downloadInput(currentDataVersion);
        }
      };
      moreOptionsControl.options.push({
        label: 'Rename',
        onClick: actions.renameJob
      });
      moreOptionsControl.options.push({
        label: 'Delete',
        onClick: actions.deleteJob
      });
      moreOptionsControl.options.push('separator');

      if (currentDataVersion !== -1) {
        moreOptionsControl.options.push(downloadXmlBtn);
        moreOptionsControl.options.push({
          label: 'Restore This Version',
          onClick: function onClick() {
            actions.restoreVersion(currentDataVersion);
          }
        });
      } else {
        moreOptionsControl.options.push(downloadXmlBtn);
        moreOptionsControl.options.push({
          label: 'Upload New Version',
          onClick: function onClick() {
            actions.uploadVersion();
          }
        });
      }

      moreOptionsControl.options.push('separator');
      moreOptionsControl.options.push({
        label: 'Go To Project',
        onClick: function onClick() {
          actions.openProjectPage();
        }
      });
      rightControls.push(moreOptionsControl);
    }
  }

  return React.createElement(Page.ToolBar, {
    color: "navbar",
    icon: onClose ? {
      type: 'close',
      onClick: onClose
    } : null,
    leftChildren: title || '',
    centerChildren: !disableCommands && React.createElement(EmbedToolbarButtons, {
      controls: controls
    }),
    rightChildren: !disableCommands && React.createElement(EmbedToolbarButtons, {
      controls: rightControls,
      alignRight: true
    })
  });
};

export default EmbedToolbar;